import {
  OnInit,
  Component,
} from '@angular/core';

import {
  IGenericUpsellDetails,
} from '@misc/upsell/upsell-config';
import { FeatureUpgradeService } from '@misc/upsell/upgrade.service';

const PENDO_PRIMARY_CTA_EVENT: string = 'pendo-upsell-primary-cta-click';

@Component({
  selector: 'upsell-pendo-guide',
  templateUrl: './upsell-pendo-guide.component.html',
})
export class UpsellPendoGuideComponent implements OnInit {
  constructor(
    private featureUpgradeService: FeatureUpgradeService,
  ) { }

  public ngOnInit(): void {
    setTimeout(this.loadGuides.bind(this), 1000);
  }

  private loadGuides(): void {
    if (window['pendo']) {
      window['pendo'].loadGuides().then(() => {
        window.addEventListener(PENDO_PRIMARY_CTA_EVENT, this.requestUpsell.bind(this));
      });
    }
  }

  private requestUpsell(e: CustomEvent): void {
    if (!e.detail) return;

    const upsellDetails: IGenericUpsellDetails = e.detail;

    const upsellParams: IGenericUpsellDetails = {
      campaign_type: '',
      utm_params: upsellDetails.utm_params,
      url_of_most_recent_mst_fill: window.location.href,
      offer_type: upsellDetails.offer_type ?? '',
      cta_content: upsellDetails.cta_content ?? '',
      fe_test_info: upsellDetails.fe_test_info ?? '',
      product_interest: upsellDetails.product_interest ?? '',
      upsell_product_interest: upsellDetails.upsell_product_interest ?? '',
    };
    this.featureUpgradeService.pendoUpsell(upsellParams).subscribe();
  }
}
